import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ServiceDataResultOfAppModuleReport } from 'gql/graphql';

import { useEffect, useMemo } from 'react';

import { appModulesReportGql } from '../sistemInformationQueries';

const { REACT_APP_REPO_COMMIT, REACT_APP_REPO_BRANCH, REACT_APP_BUILDDATE, REACT_APP_REPO_TAG } = process.env;

const requestId = 'appModulesReport';

export const getUpdateHeadData = (items: ServiceDataResultOfAppModuleReport[]) => [
    ...(items.length
        ? [
              {
                  data: {
                      name: 'Frontend',
                      release: '6.0',
                      buildDate: REACT_APP_BUILDDATE,
                      branch: REACT_APP_REPO_BRANCH,
                      commit: REACT_APP_REPO_COMMIT,
                      tag: REACT_APP_REPO_TAG,
                      healthCheckData: {
                          status: '',
                      },
                  },
              },
          ]
        : []),
    ...items,
];

export const useSystemInformationData = () => {
    const variables = useMemo(
        () => ({
            includeHealth: true,
            includeResources: true,
        }),
        [],
    );

    const [modulesReportDataReset] = useResetStoreData({ requestId });

    useEffect(() => {
        modulesReportDataReset(undefined);
    }, [modulesReportDataReset]);

    const [appModulesReportData, appModulesDataStatus, ,] = useRequest({
        requestId,
        query: appModulesReportGql,
        variables,
    });

    const systemDataIsLoading = useMemo(() => appModulesDataStatus === RequestStatus.FETCHING, [appModulesDataStatus]);

    const rowData = getUpdateHeadData(appModulesReportData?.appModulesReport?.items || []);

    return {
        rowData,
        systemDataIsLoading,
    };
};
